const func = ($target) => {
    $(document).ready(function() {

        let onlyThreeCard = $('.random-card-page').attr('data-three-card')

        function shuffle(array) {
            let currentIndex = array.length, randomIndex;

            while (currentIndex != 0) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                [array[currentIndex], array[randomIndex]] = [
                    array[randomIndex], array[currentIndex]];
            }
            
            return array;
        }

        let cards = $('#cards-container .random-card').toArray();
        cards = shuffle(cards);
        let cardLength = onlyThreeCard ? 3 : cards.length; 
        
        $('#cards-container').empty();
        for (let i = 0; i < cardLength; i++) {
            $('#cards-container').append(cards[i]);
        }
    });
};

export default func;
